import PropTypes from "prop-types"
import styled from "styled-components"

import Modal from "components/ui/modal"
import VibeSuccess from "jewlr/main/vibe/vibe-success"

const Container = styled.div`
  display: flex;
  justify-content: center;
  & > div {
    display: flex;
    flex-direction: column;
  }
  margin: ${(props) => (props.margin ? props.margin : "")};
  margin-top: -1px;
  max-height: 600px;
  overflow-y: auto;
  text-align: center;
`

const VibeModal = ({ promoCode, showVibeModal, toggleVibeModal }) => {
  return (
    <Modal
      height="fit-content"
      label="VIBE"
      onClose={() => toggleVibeModal(false)}
      show={showVibeModal}
      width="855px"
    >
      <Container>
        <VibeSuccess promoCode={promoCode} />
      </Container>
    </Modal>
  )
}

VibeModal.propTypes = {
  promoCode: PropTypes.string,
  routerHash: PropTypes.string,
  showVibeModal: PropTypes.bool,
  toggleVibeModal: PropTypes.func,
}

export default VibeModal
